import { render, staticRenderFns } from "./AtributosNivelesCard.vue?vue&type=template&id=230d29ee&scoped=true"
import script from "./AtributosNivelesCard.vue?vue&type=script&lang=js"
export * from "./AtributosNivelesCard.vue?vue&type=script&lang=js"
import style0 from "./AtributosNivelesCard.vue?vue&type=style&index=0&id=230d29ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d29ee",
  null
  
)

export default component.exports